import PropTypes from 'prop-types';
import React from 'react';

function PaymentView(props) {
  let { data, refFormats } = props;

  return (
    <table className="table">
      <thead>
        <tr>
          <th>Payment Type</th>
          <th>Tipping Enabled</th>
          <th>Shortcut in Register Page</th>
          <th>Fixed Payment Amount</th>
          <th>Reference Number Format</th>
        </tr>
      </thead>
      <tbody>
        {
          data ? data.map(payment => {
            let refFormat = refFormats.find(({id})=>id === payment.reference_number_id)
            return (
              <tr key={ payment.id }>
                <td>{ payment.name }</td>
                <td>{ payment.tipping_enabled ?
                        <span className="label label-success">Enabled</span> :
                        <span className="label label-default">off</span>
                    }
                </td>
                <td>{ payment.shortcut_enabled ?
                  <span className="label label-success">Enabled</span> :
                  <span className="label label-default">off</span>
                }</td>
                <td>{ payment.fixed_amount_enabled?payment.fixed_amount:<span className="label label-default">off</span> }</td>
                <td>{refFormat?`${refFormat.name} (${refFormat.format})`:<span className="label label-default">Default</span>}</td>
              </tr>
            )
        }) : null
        }
      </tbody>
    </table>
  );
}
PaymentView.propTypes = {
  data: PropTypes.array,
  refFormats: PropTypes.array,
};

export default PaymentView;



/** WEBPACK FOOTER **
 ** ./client/pages/settings/payments/payment-type-view.js
 **/